import { render } from "./TripPlannerApp.vue?vue&type=template&id=a87accd0&scoped=true"
import script from "./TripPlannerApp.vue?vue&type=script&lang=js"
export * from "./TripPlannerApp.vue?vue&type=script&lang=js"

import "./TripPlannerApp.vue?vue&type=style&index=0&id=a87accd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87accd0"]])

export default __exports__